import React, { useState } from "react";
import Footer2 from "components/Footers/Footer2";
import AdminNavbar from "components/Navbars/AdminNavbar";
import banner from "assets/img/new/banner.png";
import punithrajkumar from "assets/img/punithrajkumar.jpg";
import suneetha from "assets/img/suneetha.jpg";
import spoorthi from "assets/img/spoorthi.jpg";
import bindurana from "assets/img/bindurana.jpg";
import shruthikiran from "assets/img/shruthukiran.jpg";
import sunithaa from "assets/img/sunithaa.png";
import stella from "assets/img/stella.png";

export default function Founder() {
  return (
    <>
      <AdminNavbar />
      <section
        className=" xl:block lg:block md:block sm:hidden hidden"
        style={{
          backgroundColor: "#f0f7fa",
          backgroundImage: `url(${banner})`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "105% auto",
        }}
      >
        <div className="text-center justify-center xl:w-11/12 lg:w-11/12 md:w-11/12 w-12/12  md:pt-24 md:pb-20 lg:pt-28 lg:pb-20 xl:pt-36 xl:pb-32 mx-auto xl:mt-0 lg:mt-0 md:mt-12">
          <h1
            className="text-black xl:text-6xl lg:text-4xl md:text-3xl font-semibold xl:pt-1 "
            style={{ lineHeight: 1.4 }}
          >
            Our Team
          </h1>
        </div>
      </section>

      {/* mobilebanner */}
      <section
        className=" xl:hidden lg:hidden md:hidden sm:block block mt-18"
        style={{
          backgroundColor: "#f0f7fa",
          // backgroundImage: `url(${banner})`,
          backgroundPosition: "center center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "contain",
        }}
      >
        <div className="text-center justify-center">
          <h1
            className="text-black text-3xl font-semibold  pt-16 pb-16"
            style={{ lineHeight: 1.4 }}
          >
            Our Team
          </h1>
        </div>
      </section>

      <section className="xl:py-12 lg:py-12 md:py-12 py-8 container mx-auto parkinsans xl:px-0 lg:px-4 md:px-4 px-4 xl:mt-0 lg:mt-0 md:mt-0 mt-12 xl:block lg:block md:block sm:hidden hidden">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-8 xl:grid-cols-8 gap-4 ">
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1 xl:block lg:block md:hidden sm:block block">
            <img
              src={punithrajkumar}
              alt="Ashwini"
              className="xl:w-9/12 lg:w-9/12 md:w-12/12 w-12/12 justify-center mx-auto rounded-lg h-auto"
            ></img>
          </div>

          {/* tab view */}
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1 xl:hidden lg:hidden md:block sm:hidden hidden">
            <img
              src={punithrajkumar}
              alt="Ashwini"
              className=" md:w-12/12 justify-center mx-auto rounded-lg md:h-500 objectfit"
            ></img>
          </div>

          <div className="xl:col-span-5 lg:col-span-5 md:col-span-5 col-span-1 xl:pt-8">
            <h6 className="xl:text-lg font-bold text-peach">About</h6>
            <h2 className="xl:text-5xl lg:text-5xl md:text-3xl text-2xl lg:pt-2 md:pt-2 pt-2 xl:pt-2 font-bold text-black text-left">
              Ashwini Puneeth RajKumar
            </h2>
            <p className="xl:text-2xl lg:text-2xl text-2xl text-blue font-semibold text-left xl:pt-2 pt-2">
              CO-FOUNDER & DIRECTOR, JUNIOR TOES
            </p>
            <p
              className="xl:pt-4 xl:text-xl lg:text-xl md:text-base text-xl lg:pt-4 pt-4 w-12/12 text-justify xl:w-12/12"
              style={{ lineHeight: 1.8 }}
            >
              A visionary and dynamic leader, Ashwini Puneeth Rajkumar is on a
              mission to revolutionize the education space. Fuelled by her
              unwavering passion for making a meaningful impact, she embarks on
              this journey with the sharted dream she had with her late husband,
              actor Puneeth Rajkumar.
            </p>
            <p
              className="xl:pt-2 pt-2 w-12/12 xl:text-xl lg:text-xl md:text-base text-xl text-justify xl:w-12/12"
              style={{ lineHeight: 1.8 }}
            >
              With a deep commitment to shaping the future of children, Ashwini
              is collaborating with education experts to bring a world-class
              curriculum and innovative teaching methodologies to Junior Toes.
              Her goal is to transform early education, empowering young minds
              to become the change-makers and leaders of tomorrow.
            </p>
          </div>
        </div>
      </section>

      <section className="xl:py-12 lg:py-12 md:py-12 py-4 container mx-auto parkinsans xl:px-0 lg:px-4 md:px-4 px-4 xl:mt-0 lg:mt-0 md:mt-0 xl:block lg:block md:block sm:hidden hidden">
        <div
          className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-8 xl:grid-cols-8 gap-4  xl:pl-12
"
        >
          <div className="xl:col-span-5 lg:col-span-5 md:col-span-5 col-span-1">
            <h6 className="xl:text-lg text-lg font-bold text-peach">About</h6>
            <h2 className="xl:text-5xl lg:text-4xl md:text-3xl text-2xl pt-2 xl:pt-2 font-bold text-black text-left">
              Sunitha Gowda
            </h2>
            <p className="xl:text-2xl text-2xl pt-2 text-blue font-semibold text-left xl:pt-2 uppercase">
              Founder & Managing Director, JUNIOR TOES
            </p>
            <p
              className="xl:pt-4 xl:text-xl lg:text-xl md:text-base text-xl w-12/12 pt-4 text-justify xl:w-12/12"
              style={{ lineHeight: 1.8 }}
            >
              With over 20 years of experience in education, Sunitha Gowda is a
              passionate educationist and the current Chairman of Delhi Public
              International School. Her unwavering commitment to early childhood
              education has transformed her school into a beacon of excellence.
              Continuously striving for growth and innovation, she has dedicated
              her career to providing the best learning environment for
              children.
            </p>
            <p
              className="xl:pt-2 pt-2 w-12/12 lg:text-xl md:text-base text-xl xl:text-xl text-justify xl:w-12/12"
              style={{ lineHeight: 1.8 }}
            >
              Now, through Junior Toes, she embarks on a bold mission to
              revolutionize education, shaping young minds and inspiring a
              brighter, more promising future for the next generation.
            </p>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1 xl:block lg:block md:hidden sm:block block">
            <img
              src={sunithaa}
              alt="Ashwini"
              className="xl:w-9/12 lg:w-12/12 md:w-12/12 w-12/12 justify-center mx-auto rounded-lg h-auto"
            ></img>
          </div>
          {/* tab view */}
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1 xl:hidden lg:hidden md:block sm:hidden hidden">
            <img
              src={sunithaa}
              alt="Ashwini"
              className=" md:w-12/12  justify-center mx-auto rounded-lg md:h-500 object-fit"
            ></img>
          </div>
        </div>
      </section>

      <section className="xl:py-12 lg:py-12 md:py-12 py-8 container mx-auto parkinsans xl:px-0 lg:px-4 md:px-4 px-4 xl:mt-0 lg:mt-0 md:mt-0 mt-12 xl:block lg:block md:block sm:hidden hidden">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-8 xl:grid-cols-8 gap-4 ">
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1 xl:block lg:block md:hidden sm:block block ">
            <img
              src={spoorthi}
              alt="Ashwini"
              className="xl:w-10/12 lg:w-12/12 md:w-12/12 w-12/12 justify-center mx-auto rounded-lg h-auto"
            ></img>
          </div>
          {/* tab view */}
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1 xl:hidden lg:hidden md:block sm:hidden hidden ">
            <img
              src={spoorthi}
              alt="Ashwini"
              className=" md:w-12/12  justify-center mx-auto rounded-lg md:h-500 object-fit"
            ></img>
          </div>
          <div className="xl:col-span-5 lg:col-span-5 md:col-span-5 col-span-1 xl:pt-12">
            <h6 className="xl:text-lg text-lg font-bold text-peach">About</h6>
            <h2 className="xl:text-5xl lg:text-4xl md:text-3xl text-2xl pt-2 xl:pt-2 font-bold text-black text-left">
              Spoorthi Vishwas
            </h2>
            <p className="xl:text-2xl text-2xl pt-2 text-blue font-semibold text-left xl:pt-2">
              CO-FOUNDER & CEO, JUNIOR TOES
            </p>
            <p
              className="xl:pt-4 xl:text-xl pt-4 lg:text-xl md:text-base text-xl w-12/12 text-justify xl:w-12/12"
              style={{ lineHeight: 1.8 }}
            >
              An actor turned entrepreneur, Spoorthi Vishwas is a certified
              leadership coach, MBA & PGDM graduate, currently pursuing a
              doctorate at the Swiss School of Business and Management, Geneva.
              Throughout her journey, she has continually redefined success by
              inspiring greatness and touching lives. Now, as an edupreneur, she
              is ready to take on her next big challenge.
            </p>
            <p
              className="xl:pt-2 xl:text-xl lg:text-xl md:text-base text-xl w-12/12 text-justify xl:w-12/12"
              style={{ lineHeight: 1.8 }}
            >
              Fuelled by a passion for shaping young minds and nurturing future
              leaders, Spoorthi has co-founded Junior Toes, a transformative
              venture dedicated to revolutionizing early education.
            </p>
          </div>
        </div>
      </section>
      {/* <section className="xl:py-12 lg:py-12 md:py-12 py-4 container mx-auto parkinsans xl:px-0 lg:px-4 md:px-4 px-4 xl:mt-0 lg:mt-0 md:mt-0 xl:block lg:block md:block sm:hidden hidden">
        <div className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-8 xl:grid-cols-8 gap-4 ">
          <div
            className="xl:col-span-5 lg:col-span-5 md:col-span-5 col-span-1
 xl:pl-12"
          >
            <h6 className="xl:text-lg text-lg font-bold text-peach">About</h6>
            <h2 className="xl:text-5xl lg:text-4xl md:text-3xl text-2xl pt-2 xl:pt-2 font-bold text-black text-left">
            Dr. Stella Pandhare
            </h2>
            <p className="xl:text-2xl text-2xl pt-2 text-blue font-semibold text-left xl:pt-2 uppercase xl:w-0 lg:w-10/12">
            Chief Academic Advisor
            </p>
            <p
              className="xl:pt-4 xl:text-xl pt-4 lg:text-xl md:text-base text-xl w-12/12 text-justify xl:w-12/12"
              style={{ lineHeight: 1.8 }}
            >
              Dr. Stella Pandhare is a trailblazer in Indian education, renowned for
              founding over 50 schools, authoring 800+ textbooks, and developing
              850 educational games, thousands of lesson plans, and assessments.
              She established India’s largest private-sector R&D center in
              education, rivaling NCERT in intellectual property creation, and
              has mentored over 2,000 educators while creating 200+ training
              programs. As the pioneer of The Millennium School and Millennium
              World School brands and the visionary behind the transformative
              Antah: Prerana Learning System, she is committed to fostering
              social entrepreneurs and redefining learning excellence.
            </p>
            <p
              className="xl:pt-2 pt-2 w-12/12 lg:text-xl md:text-base text-xl xl:text-xl text-justify xl:w-12/12"
              style={{ lineHeight: 1.8 }}
            >
              Dr. Rana now joins Junior Toes as the architect and advisor of its
              groundbreaking curriculum, bringing unparalleled expertise to
              inspire a new era of education.
            </p>
          </div>
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1  xl:block lg:block md:hidden sm:block block">
            <img
              src={stella}
              alt="stella"
              className="xl:w-10/12 lg:w-12/12 md:w-12/12 w-12/12 justify-center mx-auto rounded-lg h-auto"
            ></img>
          </div>

          
          <div className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1  xl:hidden lg:hidden md:block sm:hidden hidden">
            <img
              src={stella}
              alt="Ashwini"
              className=" md:w-12/12  justify-center mx-auto rounded-lg md:h-540 object-fit"
            ></img>
          </div>
        </div>
      </section> */}

      <section className="xl:py-12 lg:py-12 md:py-12 py-12 container mx-auto parkinsans xl:px-0 lg:px-4 md:px-4 px-4 xl:mt-0 lg:mt-0 md:mt-0  xl:pb-0 lg:pb-0 md:pb-0 pb-12 xl:block lg:block md:block sm:hidden hidden">
        <div
          className="grid grid-cols-1 sm:grid-cols-1 md:grid-cols-8 lg:grid-cols-8 xl:grid-cols-8 gap-4 
"
        >
          
          <div
            className="xl:col-span-5 lg:col-span-5 md:col-span-5 col-span-1 xl:pt-20 lg:pt-12
 "
          >
            <h6 className="xl:text-lg text-lg font-bold text-peach">About</h6>
            <h2 className="xl:text-5xl lg:text-4xl md:text-3xl text-2xl xl:pt-2 font-bold text-black text-left">
              Shruthi Kiran
            </h2>
            <p className="xl:text-2xl text-2xl pt-2 text-blue font-semibold text-left xl:pt-2">
              DIRECTOR, JUNIOR TOES
            </p>
            <p
              className="xl:pt-4 xl:text-xl pt-4 lg:text-xl md:text-base text-xl w-12/12  xl:w-12/12"
              style={{ lineHeight: 1.8 }}
            >
              A passionate edupreneur dedicated to shaping young minds, Shruthi
              Kiran brings her vision and expertise to Junior Toes. Joining
              forces with a dynamic team of women leaders, she is committed to
              fostering a new age of education rooted in innovation, traditional
              values, and holistic growth for children.
            </p>
            <p
              className="xl:pt-2 xl:text-xl text-justify xl:w-12/12 pt-2 lg:text-xl md:text-base text-xl w-12/12"
              style={{ lineHeight: 1.8 }}
            >
              Shruthi’s unwavering passion for early childhood education
              inspires her journey to nurture future-ready learners.
            </p>
          </div>



          <div className="xl:col-span-3 lg:col-span-3 md:col-span-3 col-span-1  ">
            <img
              src={shruthikiran}
              alt="sruthikiran"
              className="xl:w-10/12 lg:w-12/12 md:w-12/12 w-12/12 justify-center mx-auto rounded-lg h-auto"
            ></img>
          </div>
        </div>
      </section>

      {/* mobile view */}
      <section className=" container mx-auto parkinsans  px-4  mt-12 xl:hidden lg:hidden md:hidden sm:block block">
        <div className=" ">
          <div className="">
            <img
              src={punithrajkumar}
              alt="Ashwini"
              className=" w-12/12  rounded-lg "
            ></img>
          </div>

          <div className="pt-4">
            <h6 className="text-lg font-bold text-peach">About</h6>
            <h2 className="text-2xl  pt-2  font-bold text-black text-left">
              Ashwini Puneeth RajKumar
            </h2>
            <p className="text-2xl text-blue font-semibold text-left pt-2">
              CO-FOUNDER & DIRECTOR, JUNIOR TOES
            </p>
            <p className=" text-xl  pt-4" style={{ lineHeight: 1.8 }}>
              A visionary and dynamic leader, Ashwini Puneeth Rajkumar is on a
              mission to revolutionize the education space. Fuelled by her
              unwavering passion for making a meaningful impact, she embarks on
              this journey with the sharted dream she had with her late husband,
              actor Puneeth Rajkumar.
            </p>
            <p className="pt-2 text-xl " style={{ lineHeight: 1.8 }}>
              With a deep commitment to shaping the future of children, Ashwini
              is collaborating with education experts to bring a world-class
              curriculum and innovative teaching methodologies to Junior Toes.
              Her goal is to transform early education, empowering young minds
              to become the change-makers and leaders of tomorrow.
            </p>
          </div>
        </div>

        <div className="mt-12 ">
          <div className="">
            <img
              src={sunithaa}
              alt="Ashwini"
              className=" w-12/12  rounded-lg "
            ></img>
          </div>

          <div className="pt-4">
            <h6 className="text-lg font-bold text-peach">About</h6>
            <h2 className="text-2xl  pt-2  font-bold text-black text-left">
              Sunitha Gowda
            </h2>
            <p className="text-2xl text-blue font-semibold text-left pt-2 uppercase">
              Founder & Managing Director, JUNIOR TOES
            </p>
            <p className=" text-xl  pt-4" style={{ lineHeight: 1.8 }}>
              With over 20 years of experience in education, Sunitha Gowda is a
              passionate educationist and the current Chairman of Delhi Public
              International School. Her unwavering commitment to early childhood
              education has transformed her school into a beacon of excellence.
              Continuously striving for growth and innovation, she has dedicated
              her career to providing the best learning environment for
              children. Now, through Junior Toes, she embarks on a bold mission
              to revolutionize education, shaping young minds and inspiring a
              brighter, more promising future for the next generation.
            </p>
          </div>
        </div>



        <div className="mt-12 ">
          <div className="">
            <img
              src={spoorthi}
              alt="Ashwini"
              className=" w-12/12  rounded-lg "
            ></img>
          </div>

          <div className="pt-4">
            <h6 className="text-lg font-bold text-peach">About</h6>
            <h2 className="text-2xl  pt-2  font-bold text-black text-left">
            Spoorthi Vishwas
            </h2>
            <p className="text-2xl text-blue font-semibold text-left pt-2 uppercase">
            CO-FOUNDER & CEO, JUNIOR TOES
            </p>
            <p className=" text-xl  pt-4" style={{ lineHeight: 1.8 }}>
            An actor turned entrepreneur, Spoorthi Vishwas is a certified leadership coach, MBA & PGDM graduate, currently pursuing a doctorate at the Swiss School of Business and Management, Geneva. Throughout her journey, she has continually redefined success by inspiring greatness and touching lives. Now, as an edupreneur, she is ready to take on her next big challenge.

Fuelled by a passion for shaping young minds and nurturing future leaders, Spoorthi has co-founded Junior Toes, a transformative venture dedicated to revolutionizing early education.
            </p>
          </div>
        </div>




        {/* <div className="mt-12 ">
          <div className="">
            <img
              src={stella}
              alt="stella"
              className=" w-12/12  rounded-lg "
            ></img>
          </div>

          <div className="pt-4">
            <h6 className="text-lg font-bold text-peach">About</h6>
            <h2 className="text-2xl  pt-2  font-bold text-black text-left">
            Dr. Stella Pandhare
            </h2>
            <p className="text-2xl text-blue font-semibold text-left pt-2 uppercase">
            Chief Academic Advisor
            </p>
            <p className=" text-xl  pt-4" style={{ lineHeight: 1.8 }}>
           Dr. Stella Pandhare is a trailblazer in Indian education, renowned for founding over 50 schools, authoring 800+ textbooks, and developing 850 educational games, thousands of lesson plans, and assessments. She established India’s largest private-sector R&D center in education, rivaling NCERT in intellectual property creation, and has mentored over 2,000 educators while creating 200+ training programs. As the pioneer of The Millennium School and Millennium World School brands and the visionary behind the transformative Antah: Prerana Learning System, she is committed to fostering social entrepreneurs and redefining learning excellence.

Dr. Rana now joins Junior Toes as the architect and advisor of its groundbreaking curriculum, bringing unparalleled expertise to inspire a new era of education.
            </p>
          </div>
        </div> */}


        <div className="mt-12 ">
          <div className="">
            <img
              src={shruthikiran}
              alt="Ashwini"
              className=" w-12/12  rounded-lg "
            ></img>
          </div>

          <div className="pt-4">
            <h6 className="text-lg font-bold text-peach">About</h6>
            <h2 className="text-2xl  pt-2  font-bold text-black text-left">
            Shruthi Kiran
            </h2>
            <p className="text-2xl text-blue font-semibold text-left pt-2 uppercase">
            DIRECTOR, JUNIOR TOES
            </p>
            <p className=" text-xl  pt-4" style={{ lineHeight: 1.8 }}>
            A passionate edupreneur dedicated to shaping young minds, Shruthi Kiran brings her vision and expertise to Junior Toes. Joining forces with a dynamic team of women leaders, she is committed to fostering a new age of education rooted in innovation, traditional values, and holistic growth for children.

Shruthi’s unwavering passion for early childhood education inspires her journey to nurture future-ready learners.
            </p>
          </div>
        </div>
      </section>
      {/* endd */}
      <Footer2 />
    </>
  );
}
